import { 
    LOGIN_SUCCESS, SET_PROFILE_IMAGE, SET_OTP, OTP_REQUIRED, UPDATE_USER_DETAILS
} from '../types';
import { REHYDRATE } from 'redux-persist';

const INITIAL_STATE = {
    id: 0,
    role: 'Anonymous',
    name: 'Never Logged In',
    surname: '',
    active: false,
    loggedInBefore: false,

    auth: {
        username: '',
        password: ''
    },

    otp_mfa_enabled: false,
    otp_sms_enabled: false,
    otp_email_enabled: false
}

export default (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case REHYDRATE: 
            return { ...state, ...(action.payload || {}).user, auth: { username: '', password: '' } }
        case LOGIN_SUCCESS: 
            return { ...state, ...action.user, loggedInBefore: true, auth: { username: '', password: '' } }        
        case SET_OTP:
            return { ...state, otp_mfa_enabled: Boolean(action.mfa), otp_email_enabled: Boolean(action.email), otp_sms_enabled: Boolean(action.sms) };
        case OTP_REQUIRED:
            return { ...state, auth: { ...action.payload } }
        case UPDATE_USER_DETAILS: 
            return { ...state, ...(action.payload.id === state.id ? action.payload : {}) }
        case SET_PROFILE_IMAGE:
            return { ...state, image: action.payload }
        default:
            return state;
    }
}
